import React, {useEffect} from "react";
import useRegister from "../../hooks/useRegister";
import World from "../../world";
import ActionLink from "../ActionLink";
import { useRouter } from "next/router";
import { Facebook } from "../OIDC";

type Props = {
    world: World;
};

const Pricing = (props: Props) => {
    const router = useRouter();
    const onSuccess = () => {
        router.push("/dashboard/[[...all]]", "/dashboard");
    };
    const { onChange, onSubmit, error, isPending } = useRegister(props.world,onSuccess);
    useEffect(() => {
        (window as any).fbq("track", "Lead");
    }, []);

    return (
    <div className="lp-container pricing-container">
      <div className="pricing-box">
         <p className="receive">You'll Receive</p>
         <ul>
            <li>Unique Phone Number</li>
            <li>Private Photo Gallery</li>
            <li>Live Photo Stream</li>
         </ul>
         <div style={{paddingBottom: "16px"}} className="price" id="redpri">$159</div>

		<Facebook  />
		<br />
		<p className="receive"></p>
		<br />
         <form id="form" className="discount-form show-form" onSubmit={onSubmit}>
            {error && (
                <p><span className="form-error">{error.message}</span></p>
            )}
            {error && error.status === 409 && (
                <div style={{paddingBottom: "16px"}}>
                    <ActionLink primary href="/dashboard">Log In?</ActionLink>
                </div>
            )}
            <div>
               <input type="text" id="full_name" className="text-input" name="name" placeholder="name" onChange={onChange} />
            </div>
            <div>
               <input type="text" id="email" className="text-input" name="email" placeholder="email" onChange={onChange} />
            </div>
            <div>
               <input type="password" id="password" className="text-input" name="password" placeholder="create a password" onChange={onChange} />
            </div>
            <button type="submit" className="pricing-get-it-now">Sign Up Now</button>
         </form>

         <div className="questions">
            Questions? Email us at
            <a href="hello@tacboard.com">hello@tacboard.com</a>
         </div>
      </div>
   </div>
)
}

export default Pricing;
